import { render, staticRenderFns } from "./export-component.vue?vue&type=template&id=31d3d5c4&scoped=true"
import script from "./export-component.vue?vue&type=script&lang=js"
export * from "./export-component.vue?vue&type=script&lang=js"
import style0 from "./export-component.vue?vue&type=style&index=0&id=31d3d5c4&scoped=true&lang=scss"
import style1 from "./export-component.vue?vue&type=style&index=1&id=31d3d5c4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d3d5c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d3d5c4')) {
      api.createRecord('31d3d5c4', component.options)
    } else {
      api.reload('31d3d5c4', component.options)
    }
    module.hot.accept("./export-component.vue?vue&type=template&id=31d3d5c4&scoped=true", function () {
      api.rerender('31d3d5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/batch/export-component.vue"
export default component.exports